import { authFetch } from '@fhl-world/auth-core/webpack-esm';

export interface FetchOptions {
	method?: string;
	body?: string;
	headers?: {
		'Content-Type': string;
		'X-Idempotence-Id': string;
	};
}

export const requestHttp = async (
	url: string,
	options?: FetchOptions
): Promise<Response> => {
	return authFetch(url, {
		...options,
		cache: 'no-cache',
		headers: {
			...options?.headers,
			'x-session-id': window.salmonsession_id,
			'X-App-Name': 'client',
			'X-Device-Type': 'web',
		},
	});
};
